/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetYoutubeIntegrationBroadcastsBroadcastsQueryResponse, WebAppGetYoutubeIntegrationBroadcastsBroadcastsPathParams, WebAppGetYoutubeIntegrationBroadcastsBroadcastsQueryParams, WebAppGetYoutubeIntegrationBroadcastsBroadcasts401, WebAppGetYoutubeIntegrationBroadcastsBroadcasts403 } from "../models/WebAppGetYoutubeIntegrationBroadcastsBroadcasts";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { webAppGetYoutubeIntegrationBroadcastsBroadcasts } from "../axios/webAppGetYoutubeIntegrationBroadcastsBroadcasts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const webAppGetYoutubeIntegrationBroadcastsBroadcastsQueryKey = (station: WebAppGetYoutubeIntegrationBroadcastsBroadcastsPathParams["station"], params: WebAppGetYoutubeIntegrationBroadcastsBroadcastsQueryParams) => ["api-v2", { url: '/web-app/v1/youtube-broadcasts/:station', params: {station:station} }, ...(params ? [params] : [])] as const

export type WebAppGetYoutubeIntegrationBroadcastsBroadcastsQueryKey = ReturnType<typeof webAppGetYoutubeIntegrationBroadcastsBroadcastsQueryKey>

export function webAppGetYoutubeIntegrationBroadcastsBroadcastsQueryOptions(station: WebAppGetYoutubeIntegrationBroadcastsBroadcastsPathParams["station"], params: WebAppGetYoutubeIntegrationBroadcastsBroadcastsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = webAppGetYoutubeIntegrationBroadcastsBroadcastsQueryKey(station, params)
        return queryOptions<WebAppGetYoutubeIntegrationBroadcastsBroadcastsQueryResponse, ResponseErrorConfig<WebAppGetYoutubeIntegrationBroadcastsBroadcasts401 | WebAppGetYoutubeIntegrationBroadcastsBroadcasts403>, WebAppGetYoutubeIntegrationBroadcastsBroadcastsQueryResponse, typeof queryKey>({
         enabled: !!(station&& params),
         queryKey,
         queryFn: async ({ signal }) => {
            return webAppGetYoutubeIntegrationBroadcastsBroadcasts(station, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Computes on-air intervals from stream gaps in the requested window and enriches them with live/ended YouTube video metadata for the station channel.
 * @summary List on-air broadcasts for a station
 * {@link /web-app/v1/youtube-broadcasts/:station}
 */
export function useWebAppGetYoutubeIntegrationBroadcastsBroadcasts<TData = WebAppGetYoutubeIntegrationBroadcastsBroadcastsQueryResponse, TQueryData = WebAppGetYoutubeIntegrationBroadcastsBroadcastsQueryResponse, TQueryKey extends QueryKey = WebAppGetYoutubeIntegrationBroadcastsBroadcastsQueryKey>(station: WebAppGetYoutubeIntegrationBroadcastsBroadcastsPathParams["station"], params: WebAppGetYoutubeIntegrationBroadcastsBroadcastsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<WebAppGetYoutubeIntegrationBroadcastsBroadcastsQueryResponse, ResponseErrorConfig<WebAppGetYoutubeIntegrationBroadcastsBroadcasts401 | WebAppGetYoutubeIntegrationBroadcastsBroadcasts403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? webAppGetYoutubeIntegrationBroadcastsBroadcastsQueryKey(station, params)
         

         const query = useQuery({
          ...webAppGetYoutubeIntegrationBroadcastsBroadcastsQueryOptions(station, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<WebAppGetYoutubeIntegrationBroadcastsBroadcasts401 | WebAppGetYoutubeIntegrationBroadcastsBroadcasts403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}